import SmileWhite from "../images/SmileWhite.svg";
import { useInView } from "react-intersection-observer";
import { useState, useEffect } from "react";

const RowEnd = () => {
  const [refFact1, refFact1InView] = useInView();
  const [refFact1isVisible, setrefFact1IsVisible] = useState(false);
  useEffect(() => {
    if (refFact1InView && !refFact1isVisible) {
      setrefFact1IsVisible(true);
    } else if (!refFact1InView && refFact1isVisible) {
      setrefFact1IsVisible(false);
    }
  }, [refFact1isVisible, refFact1InView]);
  return (
    <div className="EndRow">
      <img
        className={
          refFact1isVisible
            ? "fade-in-section is-visible row m-0 text-center py-2"
            : "fade-in-section row m-0 text-center py-2"
        }
        ref={refFact1}
        src={SmileWhite}
        alt="Digikala"
      />
    </div>
  );
};

export default RowEnd;
